'use strict';

var $ = require('jquery');
var analytics = require('../utils/analytics');

var selectedTrimId;
var engineSelectCount = 0;
var engineAutoSelected = false;


var classNames = {
	engineLevel: 'engine-level',
	list: 'list',
	engineLevelContainer: 'engine-level-container',
	engineNextStep: 'engine-next-step'
};

var modifiers = {
	engineLevelContainerDisabled: 'engine-level-container--disabled',
	nextStepDisabled: 'next-step--disabled'
};

function autoSelectSingleEngine(target) {
	if (target.length > 0) {
		var engineDropDown = target[0];
		var numberOfOptions = engineDropDown.length;
		var singleOption = 2;

		if (numberOfOptions === singleOption) {
			engineAutoSelected = true;
			engineDropDown.selectedIndex = singleOption - 1;
		}
	}
}

function trackEngineSelectEvent() {
	engineSelectCount++;
	analytics.trackEvent('Car Specs Model', 'Engine Selected ' + engineSelectCount, window.parkersConfig.dataLayer.vehicle.vehicleName);
}

module.exports = {
	init: function ($context) {
		var $engineDropDowns = $.findByBem(classNames.engineLevel, classNames.list, null, $context);

		if ($engineDropDowns.length > 0) {
			$engineDropDowns.on('display', function (event, selectedTrim) {

				selectedTrimId = selectedTrim;
				$.findByBem(classNames.engineLevelContainer).toggleClass(modifiers.engineLevelContainerDisabled, selectedTrim === 'placeholder');

				$engineDropDowns.hide().filter(event.currentTarget).show();
				autoSelectSingleEngine($(event.currentTarget));

				$(event.currentTarget).trigger('change.engineList');
			});

			$engineDropDowns.on('change.engineList', function (event) {
				var selectedEngine = $(event.currentTarget).val();

				if (selectedEngine !== 'placeholder' && !engineAutoSelected) {
					trackEngineSelectEvent();
				}
				else {
					engineAutoSelected = false;
				}

				$.findByBem(classNames.engineNextStep).toggleClass(modifiers.nextStepDisabled, selectedEngine === 'placeholder');

				var derivativeId = selectedEngine === 'placeholder' ? selectedEngine : selectedTrimId + '-' + selectedEngine;
				var $derivativeDropDown = $('[data-derivative-id="' + derivativeId + '"]');
				$derivativeDropDown.trigger('display', selectedEngine);
			});
		}
	}
};